import React, { useState } from "react";
import "./GetApp.css";
import GetAppMobileImage from "../../assets/GetAppMobileImage.avif";
import GetAppGoogleImage from "../../assets/GetAppGoogleImage.avif";
import GetAppAppleImage from "../../assets/GetAppAppleImage.avif";

const GetApp = () => {
  const [email, setEmail] = useState(true);
  const [password, setPassword] = useState(false);

  const emailRadioHandler = () => {
    setEmail(true);
    setPassword(false);
  };

  const passwordRadioHandler = () => {
    setPassword(true);
    setEmail(false);
  };

  return (
    <div className="getApp flex">
      <div className="left flex">
        <img src={GetAppMobileImage} alt="Get App Mobile Image" />
      </div>
      <div className="right flex column">
        <h2>Get the Zomato app</h2>
        <p>
          We will send you a link, open it on your phone to download
          <br /> the app
        </p>
        <div className="communication flex">
          <div className="radio flex">
            <input
              type="radio"
              name="comm"
              id="email"
              className="radioBtn cursorPointer"
              onChange={emailRadioHandler}
            />
            <label htmlFor="email" className="radioBtnLabel">
              Email
            </label>
          </div>
          <div className="radio flex">
            <input
              type="radio"
              name="comm"
              id="phone"
              className="radioBtn cursorPointer"
              onChange={passwordRadioHandler}
            />
            <label htmlFor="phone" className="radioBtnLabel">
              Phone
            </label>
          </div>
        </div>
        <form className="commData flex">
          {email && <input type="email" placeholder="Email" />}
          {password && <input type="tel"  placeholder="type here..." />}
          <button type="submit">Share App Link</button>
        </form>
        <span className="downloadAppText">Download app from</span>
        <div className="downloadImage flex">
          <img src={GetAppGoogleImage} alt="Get App Google" />
          <img src={GetAppAppleImage} alt="Get App Apple" />
        </div>
      </div>
    </div>
  );
};

export default GetApp;
